import React from 'react';

function BlockTitle(props) {
  return (
    <div className={`block-title ${props.extraClass}`}>
        <h2>{props.mainTitle}</h2>
        <p>{props.headDesc}</p>
    </div>
  );
}
export default BlockTitle;